import { memo } from "react";
import { TableItemId } from "../../../../../../components/tables/TableWidget";
import { useAppDispatch } from "../../../../../../redux/hooks";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../../components/actionMenu/ActionMenu";
import { UndeliveredAwbDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { postAssociateAwbToBin } from "../../../../../../redux/api/expedition.api";
import { setClientSelectedUndeliveredAwb } from "../../../../../../redux/reducer/expedition.reducer";

function UndeliveredAwbTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  crudData: UndeliveredAwbDataInterface | null;
}) {
  const dispatch = useAppDispatch();

  const handleAssociateAwb = async () => {
    if (!crudData?.id_doctrans) return;
    dispatch(
      postAssociateAwbToBin({
        params: {
          id_doctrans: itemId,
        },
      }),
    );
  };

  const handleButtonPress = () => {
    dispatch(setClientSelectedUndeliveredAwb(crudData));
  };

  const items: ActionMenuItem[] = [
    {
      id: "associate-awb",
      label: "Asociere expeditie",
      icon: "ASSOCIATE_AWB",
      tooltip: crudData?.id_doctrans
        ? "Adauga coletul la binurile nodului destinatie, dupa confirmare."
        : "Expeditia trebuie sa aiba un AWB pentru a fi asociata.",
      disabled: !crudData?.id_doctrans,
      withConfirmationModal: {
        modalTitle: "Asociare AWB",
        modalSubtitle: `Doriti sa adaugati coletul la binurile de pe nodul ${crudData?.nodDestinatie}?`,
        modalLeftButtonVariant: "outlined",
        modalRightButtonOnClick: handleAssociateAwb,
      },
    },
    {
      id: "transfer-route",
      label: "Transfer ruta",
      icon: "CHANGE_ROUTE",
      tooltip: "Deschide transferul expeditiei pe alta ruta.",
      onClick: handleButtonPress,
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={crudData?.nodDestinatie}
      ariaLabel={`Actiuni pentru expeditia ${itemId}`}
    />
  );
}

export default memo(UndeliveredAwbTableActionButtons);
